import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseAcademies, ApiResponseAcademyList, ApiResponseAcademy } from '@/api/responses/manage/academies'

export namespace AcademiesApi {
  /**
   * 塾一覧取得(プルダウン選択肢)
   *
   * @returns 塾一覧
   */
  export async function getAcademies(): Promise<ApiResponseAcademies> {
    return await ApiBase.get('/manage/academies')
  }

  /**
   * 塾一覧取得(ページング付一覧表示)
   *
   * @param pageNumber ページ番号
   * @param count 取得件数
   * @param searchText 検索文字列
   * @returns 塾一覧
   */
  export async function searchAcademies(
    pageNumber: number,
    count: number,
    searchText?: string
  ): Promise<ApiResponseAcademyList> {
    const params = {
      pageNumber: pageNumber,
      count: count,
    }

    // 非必須のパラメータの設定
    if (searchText) {
      Object.assign(params, { searchText: searchText })
    }

    return await ApiBase.get('/manage/academies/search', params)
  }

  /**
   * 塾取得(単体)
   *
   * @param academyId 塾ID
   * @returns 塾一覧
   */
  export async function getAcademy(academyId: number): Promise<ApiResponseAcademy> {
    return await ApiBase.get(`/manage/academies/${academyId}`)
  }

  /**
   * 塾登録API
   *
   * @param name 塾名
   * @param code 塾コード
   */
  export async function createAcademy(name: string, code: string): Promise<void> {
    const params = {
      name: name,
      code: code,
    }
    await ApiBase.post('/manage/academies', params)
  }

  /**
   * 塾情報更新API
   *
   * @param id 塾ID
   * @param name 塾名
   */
  export async function updateAcademy(id: number, name: string): Promise<void> {
    const params = {
      name: name,
    }
    await ApiBase.post(`/manage/academies/${id}`, params)
  }

  /**
   * 塾削除API
   *
   * @param id 塾ID
   */
  export async function deleteAcademy(id: number): Promise<void> {
    await ApiBase.post(`/manage/academies/${id}/delete`)
  }
}
